/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantItemDto } from './tenantItemDto';


export interface BuildingHouseCareContactDto { 
    id: string;
    contractor: TenantItemDto;
    type: BuildingHouseCareContactDto.TypeEnum;
    phone: string;
    email: string;
}
export namespace BuildingHouseCareContactDto {
    export type TypeEnum = 'CLEANING' | 'GREEN_AREA_MAINTENANCE' | 'WINTER_SERVICE';
    export const TypeEnum = {
        Cleaning: 'CLEANING' as TypeEnum,
        GreenAreaMaintenance: 'GREEN_AREA_MAINTENANCE' as TypeEnum,
        WinterService: 'WINTER_SERVICE' as TypeEnum
    };
}


